import { ScrollBarDisplay } from "./Const";
export class UIConfig2 {
}
UIConfig2.modalLayerColor = "rgba(50, 50, 50, 0.2)";
UIConfig2.horizontalScrollBar = null;
UIConfig2.verticalScrollBar = null;
UIConfig2.defaultScrollStep = 25;
UIConfig2.defaultScrollDecelerationRate = 0.967;
UIConfig2.defaultScrollBarDisplay = ScrollBarDisplay.Always;
UIConfig2.defaultScrollTouchEffect = true;
UIConfig2.defaultScrollBounceEffect = true;
UIConfig2.defaultScrollSnappingThreshold = 0.1;
UIConfig2.defaultScrollPagingThreshold = 0.3;
UIConfig2.popupMenu = null;
UIConfig2.popupMenuSeperator = null;
UIConfig2.tooltipsWidget = null;
UIConfig2.defaultTooltipsShowDelay = 100;
UIConfig2.defaultComboBoxVisibleItemCount = 20;
UIConfig2.touchScrollSensitivity = 10;
UIConfig2.touchDragSensitivity = 10;
UIConfig2.clickDragSensitivity = 2;
UIConfig2.bringWindowToFrontOnClick = true;
